import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccountState {
    selectedAccount: any;
    accountData: any[];
}

const initialState: AccountState = {
    selectedAccount: null,
    accountData: []
};

export const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setSelectedAccount: (state, action: PayloadAction<any>) => {
            state.selectedAccount = action.payload;
        },
        setAccountData: (state, action: PayloadAction<any[]>) => {
            state.accountData = action.payload;
        },
        updateAccountInData: (state, action: PayloadAction<any>) => {
            state.accountData = state.accountData.map(item =>
                item.actCode.toString() === action.payload.actCode.toString() 
                    ? action.payload 
                    : item
            );
        }
    }
});

export const { setSelectedAccount, setAccountData, updateAccountInData } = accountSlice.actions;
export default accountSlice.reducer;
